import type { BoxProps } from '@mui/material/Box';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// ----------------------------------------------------------------------

type SearchNotFoundProps = BoxProps & {
  query?: string;
};

export function SearchNotFound({ query, sx, ...other }: SearchNotFoundProps) {
  if (!query) {
    return (
      <Typography variant="body2" sx={sx}>
        Kelime giriniz
      </Typography>
    );
  }

  return (
    <Box sx={{ textAlign: 'center', borderRadius: 1.5, ...sx }} {...other}>
      <Box sx={{ mb: 1, typography: 'h6' }}>Sonuç Bulunamadı</Box>

      <Typography variant="body2">
        <strong>{`"${query}"`}</strong>
        &nbsp; için herhangi bir sonuç bulunamadı.
        <br /> Hatalı yazımları kontrol edip, tekrar deneyiniz.
      </Typography>
    </Box>
  );
}
